import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GridFooter, GridFooterContainer, GridRowClassNameParams } from "@mui/x-data-grid-premium";
import React, { memo } from "react";
import { useId } from "react";
import "../EntityTable.css";

type GridLegendItemColor = "red" | "orange" | "gray" | "purple" | "green" | "blue";

export interface GridLegendItem {
    label: string;
    color: GridLegendItemColor;
    applyClass: (params: GridRowClassNameParams<any>) => boolean;
}
interface GridFooterLegendProps {
    items?: GridLegendItem[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface FooterProps {
    legendItems?: GridLegendItem[];
}

const Footer: React.FC<FooterProps> = memo(({ legendItems }) => {
    return (
        <GridFooterContainer>
            <GridFooterLegend items={legendItems} />
            <GridFooter />
        </GridFooterContainer>
    );
});

const GridFooterLegend: React.FC<GridFooterLegendProps> = memo(({ items }) => {
    const itemKey = useId();
    if (!Array.isArray(items) || !items.length) {
        return null;
    }
    return (
        <ul style={{ listStyleType: "none", padding: 0, paddingLeft: "1rem", display: "flex" }}>
            {items.map(({ color, label }) => {
                return (
                    <li style={{ marginRight: "1em" }} key={`${itemKey}_${label}`}>
                        <FontAwesomeIcon icon={faCircle} size="2xs" className={`entityTable__legend--${color}`} style={{ marginRight: "0.5em" }} />
                        {label}
                    </li>
                );
            })}
        </ul>
    );
});

export default Footer;
